export const formatImageSource = (
  source: string,
  width: number = 0,
  isSquare: boolean = false,
) => {
  if (!source) {
    return {
      src: '',
      srcSet: '',
    }
  }

  const sourceWithoutParams = source.split('?')[0]

  const squareOption = isSquare ? 'crop=1:1&' : ''

  if (width === 0) {
    return {
      src: sourceWithoutParams,
      srcSet: sourceWithoutParams,
    }
  }

  return {
    src: `${sourceWithoutParams}?${squareOption}quality=80&width=${width}`,
    srcSet: `${sourceWithoutParams}?${squareOption}quality=80&width=${width} 1x, ${sourceWithoutParams}?${squareOption}quality=80&width=${Math.floor(
      width * 1.5,
    )} 2x`,
  }
}
